import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-route-management',
  templateUrl: './route-management.component.html',
  styleUrls: ['./route-management.component.css']
})
export class RouteManagementComponent implements OnInit {

  form: any | FormGroup
  updateForm: any | FormGroup
  RouteData:any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: any = 0
  tableSizes: any = [3, 6, 9, 12];
  singleParam:any = []
  singleRoute: any = [];
  routeid: any = "";
  cid:any
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllRoute()
    this.form = this.fb.group({
      routeName: [''],
      routeDetailResponses:this.fb.array([])
    }) 
    this.addrouteDetailResponses()
  }

  onTableDataChange(event: any) {
    this.page = event.page+1;
  }

  get routeArr(){
    return this.form.get('routeDetailResponses') as FormArray;
  }

  routeDetailResponses(){
    return this.fb.group({
      "routeId": [0],
      "currentLatitude": [''],
      "currentLongitude": [''],
      "captureDateTime": new Date().getTime(),
      "status": true,
      "cid": Number(this.cid),
    })
  }
  addrouteDetailResponses(){
    this.routeArr.push(this.routeDetailResponses())
    }
  
  removerouteDetailResponses(index: number){
    this.routeArr.removeAt(index)
  }

  addRoute(){
      let body = {
          "route": {
            "version": 0,
            "isActive": true,
            "description": "",
            "routeName": String(this.form.get('routeName').value),
            "routeStatus": "Active",
            "cid": Number(this.cid)
          },
          "routeDetailResponses": this.form.get('routeDetailResponses').value,
        }

    console.log(body)
    this.generic_service.addRoute(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllRoute()
        this.toastr.success(response.message);
        this.cancelModel()
        this.form.reset()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  getAllRoute(){
    this.isLoading = true

    this.generic_service.getAllRoute().subscribe(
      (res:any)=> {
        console.log(res)
        this.RouteData = res.response
        this.isLoading = false
        this.count = res.response.length
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getRouteById(id:any){
    this.routeid = id
    this.generic_service.getRouteById(id).subscribe(
      (response:any)=>{
        this.singleRoute = []
        this.singleRoute.push(response.response)
        console.log(this.singleRoute)
        this.form.patchValue({
          routeName: response.response.route.routeName,
        })
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  seleteRoute(id:any){
    this.routeid = id
  }

  deleteRoute(){
    this.generic_service.deleteRoute(this.routeid).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllRoute()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  updateRoute(){
    let body = {
        "id": this.singleRoute[0].route.id,
        "routeId": this.singleRoute[0].route.routeId,
        "version": 0,
        "isActive": true,
        "description": "",
        "routeName": String(this.form.get('routeName').value),
        "routeStatus": "Active",
        "cid": this.cid
      }

  console.log(body)
  this.generic_service.updateRoute(body).subscribe(
    (response:any)=>{
      console.log(response)
      this.getAllRoute()
      this.toastr.success(response.message);
      this.cancelModel()
    },
    (err:any)=>{
      console.log(err)
      this.toastr.error(err.error.errors[0].description);
    },
  )
}


}